import { z } from 'zod';
import { subHeadTypeSchema } from './common.js';
import type { SubHeadType } from '../constants/sub-heads.js';

const subHeadCodeBody = z
  .string()
  .min(1, 'Code is required')
  .max(40, 'Code must be at most 40 characters')
  .regex(
    /^[A-Z][A-Z0-9_]*$/,
    'Code must start with a letter and contain only uppercase letters, digits, and underscores',
  );

const subHeadNameBody = z
  .string()
  .min(1, 'Name is required')
  .max(100, 'Name must be at most 100 characters')
  .transform((s) => s.trim());

export const createSubHeadRequestSchema = z.object({
  code: subHeadCodeBody,
  name: subHeadNameBody,
  type: subHeadTypeSchema.default('EXPENSE'),
});
export type CreateSubHeadRequest = z.infer<typeof createSubHeadRequestSchema>;

export const updateSubHeadRequestSchema = z.object({
  name: subHeadNameBody.optional(),
  type: subHeadTypeSchema.optional(),
  isActive: z.boolean().optional(),
});
export type UpdateSubHeadRequest = z.infer<typeof updateSubHeadRequestSchema>;

export interface SubHeadResponse {
  id: string;
  fundId: string;
  code: string;
  name: string;
  type: SubHeadType;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}
